import { render } from "./SectionTitle.vue?vue&type=template&id=950cd47e"
const script = {}
script.render = render

export default script